import React, { useState } from 'react';
import { SearchIcon, MenuIcon, XIcon } from 'lucide-react';
const NAV_LINKS = ['News', 'California', 'Legal', 'Business', 'Automotive', 'About'];
export function SiteHeader() {
  const [mobileOpen, setMobileOpen] = useState(false);
  return <header className="sticky top-0 z-40 w-full border-b border-rule bg-paper/95 backdrop-blur" data-id="element-60" data-mp="1np0p8urtr028">
      <div className="mx-auto flex h-16 max-w-shell items-center gap-6 px-5 sm:px-8" data-id="element-61" data-mp="1ipwhm8kjtae0">
        <a href="#" className="font-sans text-[15px] font-bold uppercase tracking-[0.18em] text-ink whitespace-nowrap" data-id="element-62" data-mp="uyipo3qb7gtk">
          California News
        </a>

        <nav aria-label="Sections" className="ml-6 hidden flex-1 lg:block" data-id="element-63" data-mp="14xzvqm9h3wq2">
          <ul className="flex items-center gap-7" data-id="element-64" data-mp="zwaiczys36yt">
            {NAV_LINKS.map(link => <li key={link} data-id="element-65" data-mp="2gasj7kv8dz0b">
                <a href="#" className="font-sans text-[13px] font-medium text-ink-soft transition-colors duration-150 ease-out hover:text-ink focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ink focus-visible:ring-offset-4" data-id="element-66" data-mp="2ga0o0b5jq3ak">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="ml-auto flex items-center gap-1" data-id="element-67" data-mp="2jija2261jasn">
          <button type="button" aria-label="Search" className="flex h-9 w-9 items-center justify-center text-ink-soft transition-colors duration-150 ease-out hover:text-ink focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ink" data-id="element-68" data-mp="2ohm9n7394ot8">
            <SearchIcon className="h-[18px] w-[18px]" strokeWidth={1.6} data-id="element-69" data-mp="20qyp9mc5g6ps" />
          </button>
          <button type="button" aria-label={mobileOpen ? 'Close menu' : 'Open menu'} aria-expanded={mobileOpen} onClick={() => setMobileOpen(open => !open)} className="flex h-9 w-9 items-center justify-center text-ink-soft transition-colors duration-150 ease-out hover:text-ink focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ink lg:hidden" data-id="element-70" data-mp="25hypp1kh96x1">
            {mobileOpen ? <XIcon className="h-5 w-5" strokeWidth={1.6} data-id="element-71" data-mp="1002e2kj1xwst" /> : <MenuIcon className="h-5 w-5" strokeWidth={1.6} data-id="element-72" data-mp="1eqhzo0fdr6ri" />}
          </button>
        </div>
      </div>

      {mobileOpen && <nav aria-label="Sections" className="border-t border-rule bg-paper lg:hidden" data-id="element-73" data-mp="m2do4ya4nzgw">
          <ul className="mx-auto max-w-shell px-5 py-2 sm:px-8" data-id="element-74" data-mp="m46xilc4kxsl">
            {NAV_LINKS.map(link => <li key={link} className="border-b border-rule last:border-b-0" data-id="element-75" data-mp="w0jsrnnbjjpg">
                <a href="#" className="block py-3 font-sans text-[14px] font-medium text-ink-soft transition-colors duration-150 ease-out hover:text-ink" data-id="element-76" data-mp="vygvciju6oap">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>}
    </header>;
}